var map = {
	"./Sample_Formatting_After.png": 283,
	"./Sample_Formatting_Before.png": 284,
	"./Sample_Outline.png": 285,
	"./Sample_Proofreading_and_formattingAfter.png": 286,
	"./Sample_Proofreading_and_formatting_Before.png": 287,
	"./Sample_Sources.png": 288,
	"./before_after_1.png": 289,
	"./before_after_cut.png": 290,
	"./icons.svg": 80,
	"./micro-1.svg": 291,
	"./micro-2.svg": 292,
	"./micro-3.svg": 293,
	"./preview1.png": 294,
	"./preview2.png": 295,
	"./preview3.png": 296,
	"./preview4.png": 297,
	"./preview5.png": 298,
	"./preview6.png": 299,
	"./services-img1.svg": 300,
	"./services-img2.svg": 301,
	"./services-img3.svg": 302,
	"./services-img4.svg": 303,
	"./source/pdf-icon.svg": 304,
	"./source/zoom-icon.svg": 305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 282;